import { render, staticRenderFns } from "./EmailPolicyPage.vue?vue&type=template&id=08706c9a&scoped=true&"
import script from "./EmailPolicyPage.vue?vue&type=script&lang=js&"
export * from "./EmailPolicyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08706c9a",
  null
  
)

export default component.exports